export default function NotFound() {
  return <div className="text-sm text-gray-600">Страница не найдена</div>;
}
